import React from 'react'
import AdxDropdown from 'components/custom/AdxDropdown'
import Typography from '@mui/material/Typography'
import AddIcon from '@mui/icons-material/Add'
import { Button } from '@mui/material'

export const options = [
  {
    value: 'option1',
    title: 'Option 1',
  },
  {
    value: 'option2',
    title: 'Option 2',
  },
  {
    value: 'option3',
    title: 'Option 3',
  },
  {
    value: 'option4',
    title: 'Option 4',
  },
]

const defaultAddNewOnClick = () => {
  // for example purpose
  alert('You clicked Add New Item button. Pass addNewOnClick prop to handle your own add new event')
}

const AdxDropdownWithAddButton = ({
  options,
  addNewOnClick = defaultAddNewOnClick,
  addNewText = 'Create New Approval Layer',
  value,
  onChange,
  sx,
  sxButton,
  children,
  ...rest
}) => {
  return (
    <AdxDropdown value={value} onChange={onChange} sx={{ ...sx }} {...rest}>
      <Button
        variant="text"
        onClick={addNewOnClick}
        fullWidth
        disableFocusRipple
        sx={{
          py: 1,
          px: 2,
          color: 'alternate.main',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          '&:hover': {
            cursor: 'pointer',
            backgroundColor: 'alternate.light',
          },
          ...sxButton,
        }}
      >
        <AddIcon color="alternate" sx={{ mr: 1.5 }} />
        <Typography variant="body1">{addNewText}</Typography>
      </Button>
      {children}
    </AdxDropdown>
  )
}

export default AdxDropdownWithAddButton
